import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import IAgreementProducts from './IAgreementProducts';
import { Table } from 'react-bootstrap';
import AgreementProductListRow from './AgreementProductListRow';

interface IAgreementProductsListProps {
    agreementProducts: IAgreementProducts[];
}

const AgreementProductsList = (props: IAgreementProductsListProps) => {
    return (
        <Table hover responsive>
            <thead>
                <tr>
                    <th>{Translate('photographer-agreement/list/header/product-name')}</th>
                    <th>{Translate('photographer-agreement/list/header/compensation')}</th>
                </tr>
            </thead>
            <tbody>
                {props.agreementProducts &&
                    props.agreementProducts.map((item: IAgreementProducts, index: number) => {
                        return <AgreementProductListRow agreementProducts={item} key={index} />;
                    })}
            </tbody>
        </Table>
    );
};

export default AgreementProductsList;
